<template>
  <PanelRow>
    <Panel class="newcontest">
      <p class="main-title1">Bounty List</p>

      <div>
        
        <div class="details-form-2">
          <div class="m-label">
            <label for="exampleInputEmail1">Bounty Type: </label>
          </div>
          <div class="m-textbox">
            <select class="custom-select" style="width:100%" @change="changeBountyType()"  v-model="selBountyType" name="selBountyType" id="selBountyType">
              <option v-for="bountyTypeOption_ in bountyTypeOption" :key="bountyTypeOption_.id" :value="bountyTypeOption_.id" >{{bountyTypeOption_.title}}</option>
            </select>
          </div>
        </div>
        <div class="table-responsive rsp-table">
        <table v-if="myQuest">
          <tr>
            <th>Id</th>
            <th>Campaign Name</th>
            <th>Project Name</th>
            <th>Company Name</th>
            <th>Company Email</th>
            <th>Name</th>
            <th>Email</th>
            <th>Date</th>
            <th>Publish</th>
            <th>Details</th>
          </tr>
          <tr v-for="contest in myQuestData" :key="contest.id">
            <td>{{contest.id}}</td>
            <td><router-link :to="{name:'admin.bountydetail', params:{'compaign_id':contest.id}}">{{contest.title}}</router-link></td>
            <td><router-link :to="{name:'admin.bountydetail', params:{'compaign_id':contest.id}}">{{contest.project_title}}</router-link></td>
            <td><router-link :to="{name:'admin.bountydetail', params:{'compaign_id':contest.id}}">{{contest.apptokens_company_name}}</router-link></td>
            <td><router-link :to="{name:'admin.bountydetail', params:{'compaign_id':contest.id}}">{{contest.apptokens_company_contact_email}}</router-link></td>
            <td><router-link :to="{name:'admin.bountydetail', params:{'compaign_id':contest.id}}">{{contest.users_f_name}} {{contest.users_l_name}}</router-link></td>
            <td><router-link :to="{name:'admin.bountydetail', params:{'compaign_id':contest.id}}">{{contest.users_email}}</router-link></td>
            <td>{{contest.created_at | formatDate}}</td>
            <td>{{contest.publish}}</td>
            <td><router-link :to="{name:'admin.bountydetail', params:{'compaign_id':contest.id}}">Visit</router-link></td>
          </tr>
        </table>
        

        <table class="table-data" v-else>
          <tr>
            <th>Id</th>
            <th>Campaign Name</th>
            <th>Project Name</th>
            <th>Company Name</th>
            <th>Company Email</th>
            <th>Name</th>
            <th>Email</th>
            <th>Date</th>
            <th>Publish</th>
            <th>Details</th>
          </tr>
          <tr>
            <td colspan="9">No record found</td>
          </tr>
        </table>
        </div>

        <div class="details-form" v-if="myQuest"></div>
        <div class="center-btn" v-if="myQuest">
          <div class="pagination">
            <a class="cont-a" @click="prev()">&laquo;</a>
            <a href="#">Current {{currentPage}}</a>
            <a href="#">Total {{totalPage}}</a>
            <a class="cont-a" @click="next()">&raquo;</a>
          </div>
        </div>

      </div>
    </Panel>
  </PanelRow>
</template>

<script>
    import List from '@/helpers/components/display/List'
    import Wizard from '@/helpers/components/display/Wizard'
    import Recordset from '@/providers/api/Recordset'
    import ModalDialogs from 'vue-modal-dialogs'
    import {list as mixin} from '@/helpers/mixins/pagination'
    import form from '@/helpers/mixins/form'
    import {reports as fields} from '@/apps/loyaltyvenue/fields'
    import {format as dateformat, getDaysInMonth} from 'date-fns'
    import _ from 'lodash'
    import Vue from 'vue';
    import JsonCSV from 'vue-json-csv';
    import { format } from "date-fns";
    import moment from "moment";

    Vue.component('downloadCsv', JsonCSV);
    Vue.filter("formatDate", function (value) {
    if (value) {
        return moment(String(value)).format("DD.MM.YYYY");
    }
    });


  export default {
    name: 'BountyList',
    mixins: [mixin],
    components: {List},
    data () {
        return {
            bountyTypeOption: [],
            selBountyType: "1",
            exportJSONData: [],
            myQuest: false,
            myQuestData: [],
            myQuestData2: [],
            myQuestDataALL: [],
            SelQuestName: "all",
            currentPage: 1,
            totalPage: 0,
            lastPage: 0,
            prevPage: 0,
        }
    },
    computed: {},
    asyncComputed: {
      apptoken () {
          this.async(
          'apptoken',
          apptoken => 
          this.api
          .post(
            "/sso/aquest/master/getBountyTypeData",
            {},
            {"app-token": "6e837457fd14dd0a05d8"}
          )
          .then((response) => {
          
          this.api.post('/sso/aquest/master/getTotalBountyList',
              {
                "bounty_type_id": this.selBountyType
              }, 
              {"app-token": "6e837457fd14dd0a05d8"}
            )
            .then((response) => {
                if(response.status == 200 && (response.data).length > 0) {
                response = response.data;
                this.myQuest = true;
                // this.myQuestData = response;

                this.exportJSONData = response;


                this.myQuestDataALL = response;
                this.myQuestData = [];
                for (let index = 0; index < 10; index++) {
                    if(this.myQuestDataALL[index] != undefined)
                    this.myQuestData.push(this.myQuestDataALL[index]);
                }
                this.currentPage = 1;
                this.totalPage = Math.ceil(this.myQuestDataALL.length/10);
                this.prevPage = 0;
                this.lastPage = 10;
                }
            })
            .catch((error) => {
                this.$alertify.error(error);
            })

            })
            .catch((error) => {
            console.log(error);
            })
        
        );
      },
    },
    methods: {
      prev: function () {
        if(this.currentPage > 1) {
          this.myQuestData = [];
          for (let index = this.prevPage-10; index < this.prevPage; index++) {
            if(this.myQuestDataALL[index] != undefined)
            this.myQuestData.push(this.myQuestDataALL[index]);
          }
          this.currentPage--;
          this.lastPage = this.prevPage;
          this.prevPage = this.prevPage-10;
        }
      },
      next: function () {
        if(this.currentPage < this.totalPage) {
          this.myQuestData = [];
          for (let index = this.lastPage; index < this.lastPage+10; index++) {
            if(this.myQuestDataALL[index] != undefined)
            this.myQuestData.push(this.myQuestDataALL[index]);
          }
          this.currentPage++;
          this.prevPage = this.lastPage;
          this.lastPage = this.lastPage+10;
        }
      },
      changeBountyType: function () {
        this.api.post('/sso/aquest/master/getTotalBountyList',
            {
              "bounty_type_id": this.selBountyType
            }, 
            {"app-token": "6e837457fd14dd0a05d8"}
          )
          .then((response) => {
            if(response.status == 200 && (response.data).length > 0) {
              response = response.data;
              this.myQuest = true;
              // this.myQuestData = response;

              this.exportJSONData = response;


              this.myQuestDataALL = response;
              this.myQuestData = [];
              for (let index = 0; index < 10; index++) {
                if(this.myQuestDataALL[index] != undefined)
                this.myQuestData.push(this.myQuestDataALL[index]);
              }
              this.currentPage = 1;
              this.totalPage = Math.ceil(this.myQuestDataALL.length/10);
              this.prevPage = 0;
              this.lastPage = 10;


            }
            else 
            this.myQuest = false;
          })
          .catch((error) => {
              console.log(error);
          });
      }
    },
    created () {

      this.api
      .post(
        "/sso/aquest/master/getBountyTypeData",
        {},
        {"app-token": "6e837457fd14dd0a05d8"}
      )
      .then((response) => {
        if (response.status == 200 && (response.data).length > 0) {
          this.bountyTypeOption = response.data;
        }
        else {
          this.$alertify.error(response.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    },
  }
</script>


<style>
  @import "../../assets/css/style.css";
</style>

<style lang="scss" scoped>
@import "../../assets/scss/_variables";

.statusfilters {
  @media (min-width: $lg-min) {
    flex-wrap: nowrap;
  }
  justify-content: center;
}
.statusfilter {
  flex-basis: 33.33%;
  flex-grow: 0;
  flex-shrink: 1;
  cursor: pointer;
  color: $color-primary;
  &.active,
  &:hover {
    color: $default-color;
  }
  &.active {
    background: mix(white, $color-primary, 85%);
  }
}
.contests-list {
  text-align: center;
  .btn {
    margin: 30px 0;
    @media (max-width: $sm-max) {
      margin: 20px 0;
    }
  }
  .panel {
    padding: 14px;
    a.contest {
      @media (min-width: $xs-min) {
        display: flex;
      }
      > * {
        flex-basis: 50%;
        flex-grow: 0;
        flex-shrink: 0;
        overflow: hidden;
        position: relative;
        @media (min-width: $xs-min) {
          width: 50%;
        }
      }
      > figure {
        img {
          width: 100%;
        }
        >>> .placeholder {
          padding: 16%;
        }
        figcaption {
          position: absolute;
          display: inline-block;
          width: 73px;
          height: 73px;
          line-height: 30px;
          font-size: 40px;
          background: white;
          bottom: -10px;
          right: -10px;
          color: $primary-color;
          padding: 10px;
        }
      }
      > section {
        text-align: left;
        @media (min-width: $xs-min) {
          display: flex;
          flex-direction: column;
        }
        > * {
          width: 100%;
          @include font-size(18px);
        }
        > h3 {
          @include font-size(20px);
          margin: 0 0 9px;
        }
        > p {
          overflow: hidden;
          flex-grow: 1;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .cell-status >>> {
          dt,
          dd {
            display: inline;
            line-height: 2;
          }
          dd {
            color: $color-primary;
            font-weight: 700;
            &::before {
              content: " ";
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/sections/general/BountyList.vue